<template>
  <div class="row">
    <div class="col-sm-3"></div>
    <div class="col-sm-6 text-center">
      <h5>Guest Pass</h5>
      <p>By invitiation only</p>
    </div>
    <div class="col-sm-3"></div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>